import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-engfinity-club',
  templateUrl: './engfinity-club.component.html',
  styleUrls: ['./engfinity-club.component.scss']
})
export class EngfinityClubComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
